import { render, staticRenderFns } from "./tabBookingMasterUICustom.vue?vue&type=template&id=5add58e3&scoped=true&"
import script from "./tabBookingMasterUICustom.vue?vue&type=script&lang=js&"
export * from "./tabBookingMasterUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabBookingMasterUICustom.vue?vue&type=style&index=0&id=5add58e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add58e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5add58e3')) {
      api.createRecord('5add58e3', component.options)
    } else {
      api.reload('5add58e3', component.options)
    }
    module.hot.accept("./tabBookingMasterUICustom.vue?vue&type=template&id=5add58e3&scoped=true&", function () {
      api.rerender('5add58e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMasterUICustom.vue"
export default component.exports